module.exports = __webpack_public_path__ + "img/hover.d12481ee.svg";